import styled from "styled-components";
import { Drawer } from "antd";

export const Container = styled(Drawer)`
  .ant-drawer-body {
    padding: 24px 0px 10px 0px;
  }

  .drawerForm {
    width: 100%;
    padding: 0px 24px;
    min-height: -moz-calc(100vh - 165px);
    min-height: -webkit-calc(100vh - 165px);
    min-height: calc(100vh - 165px);

    .ant-row-flex + .ant-row-flex {
      margin-top: 8px;
    }
  }

  .rowLabel {
    margin: 8px 0px;
  }

  span.subTitle {
    font-size: 14px;
    color: #000;
    margin-bottom: 10px;
  }

  label {
    color: #9074bf;
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    margin-left: 15px;
    margin-bottom: 8px;
    &.error {
      color: #d44c4c;
      margin-left: 15px;
    }
  }

  .ant-select {
    width: 100%;
  }

  .ant-input-number {
    width: 80%;
  }
`;

export const Footer = styled.div`
  position: absolute;
  top: 102%;
  left: -10px;

  width: 100%;

  border-top: 1px solid #e8e8e8;
  padding: 16px;
  border-radius: 0 0 4px 4px;

  .buttonsDiv {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    /* padding-right: 24px; */

    button:first-of-type {
      margin-right: 12px !important;
    }
  }

  .ant-row-flex {
    margin: 0;
  }

  .selectDiv {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    span {
      font-family: "Asap", sans-serif;
      font-size: 14px;
      font-weight: bold;
      margin-right: 8px;
    }
  }
`;
